<template >
    <div class="float-aperture" id="moveDiv" 
        @mousedown="down"
        @click="goGroupMembers"
        @touchstart="down"
        @mousemove="move"
        @touchmove.prevent="move"
        @mouseup="end"
        @touchend="end">
        <i class="icon"></i>
        <span class="txt">{{$t("im.groupMembers")}}</span>
    </div>
</template>
<script>
import wxConfig from '@/utils/wxconfig';
import shareDialog from "@/components/dialogShare.vue";
export default {
    components:{
        shareDialog
    },
    props:{
        pageInfo:Object,
        chatId:{}
    },
    data(){
        return{
            flags: false,
            yPum: 0,
            ny: 0,
            dy: 0,
            position:{
                y:0
            }
        }
    },
    methods:{
        // 实现移动端拖拽
        down() {
            this.flags = true; //是否开启拖拽
            var touch;
            if (event.touches) {
                touch = event.touches[0];
            } else {
                touch = event;
            }
            this.position.y = touch.clientY;
            this.dy = moveDiv.offsetTop;
        },
        move() {
            if (this.flags) {
                var touch;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                this.ny = touch.clientY - this.position.y;
        
                this.yPum = this.dy + this.ny;
                if (this.dy + this.ny <= 10) {
                this.yPum = 0;
                } else if(this.dy + this.ny >= this.pagey -100){
                    this.yPum = this.pagey - 100;
                } else {
                this.yPum = this.dy + this.ny;
                }
                if(this.yPum){
                    if(document.documentElement.clientHeight <= (this.yPum+100)){
                        this.yPum = document.documentElement.clientHeight - moveDiv.clientHeight - 20;
                    }
                    moveDiv.style.top = this.yPum + "px";
                    moveDiv.style.bottom = "auto";
                }
                //阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
                document.addEventListener(
                "touchmove",
                function() {
                    event.preventDefault();
                },
                false
                );
            }
        },
        //鼠标释放时候的函数
        end() {
            this.flags = false;
        },
        
        // 群成员
        async goGroupMembers(){
            this.$router.push({
                path:"/im/groupList",
                query:{
                    chatId:this.chatId
                }
            })
        },
        async setWxConfig(data) {
            let self = this;
            await wxConfig.share({
                title: data.title,
                desc: data.desc,
                imgUrl: data.imgUrl,
                link: data.toUrl,
                circleFriend: function() {
                    self.changeShareState(data.pageTraceId, true);
                },
                failFriend: function() {
                    self.changeShareState(data.pageTraceId, false);
                }
            });
        },
    }
}
</script>
<style scoped lang="scss">
.float-aperture{
    position: absolute;
    touch-action: none;
    bottom: 8rem;
    right: 0;
    z-index: 999;
    background: #FFFFFF;
    box-shadow: 0 0.06rem 0.3rem 0 rgba(185,185,185,0.2);
    border-radius: 0.32rem 0 0 0.32rem;
    display: flex;
    align-items: center;
    .icon{
        width: 1.76rem;
        height: 1.76rem;
        background: url("~@/assets/img/group-member-icon.png") no-repeat;
        background-size: 100% 100%;
    }
    .txt{
        font-size: 0.64rem;
        margin-right: 0.6rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
    }
}
</style>